import { render, staticRenderFns } from "./RestoreItineraryVersionAlert.vue?vue&type=template&id=04d5a142&scoped=true&"
import script from "./RestoreItineraryVersionAlert.vue?vue&type=script&lang=js&"
export * from "./RestoreItineraryVersionAlert.vue?vue&type=script&lang=js&"
import style0 from "./RestoreItineraryVersionAlert.vue?vue&type=style&index=0&id=04d5a142&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d5a142",
  null
  
)

export default component.exports